<script setup lang="ts">
import { computed } from "vue";

import { cardActions } from "@/action/cardActions";
import { cardKey, cardMethodsKey } from "@/components/StickyNote/injectKeys";
import { action } from "@/components/action/action";
import { boardKey } from "@/components/board/injectKeys";
import IconButton from "@/components/ui/IconButton/IconButton.vue";
import { isActionVisible } from "@/components/utils/actions";
import { injectStrict } from "@/utils/vue";

const card = injectStrict(cardKey);
const cardMethods = injectStrict(cardMethodsKey);
const board = injectStrict(boardKey);

const isVisible = computed(() => isActionVisible("program", card, board.value));

const toProgram = action(cardActions.toProgram, {
  click: () => void cardMethods.animate?.("mirroring"),
});
</script>

<template>
  <IconButton v-if="isVisible" v-bind="toProgram" />
</template>
